import React from 'react'
import { InputToggleButtonProps, ToggleButtonOption } from './types'
import { KEYS } from '../../Constants/KeyCodes';

const InputToggleButton = (props: InputToggleButtonProps) => {
    const option = (option: ToggleButtonOption) => {
        const isSelected = option.value === props.value;
        const optionClasses = `input-toggle-button__option 
        ${props.manyItems ? 'input-toggle-button__option--many-items' : 'input-toggle-button__option--few-items'} 
        ${isSelected ? 'input-toggle-button__option--selected' : ''}`;
        const optionId = `${props.id}-${option.value}`;

        return (
            <div
                id={optionId}
                key={optionId}
                className={optionClasses}
                role="radio"
                tabIndex={0}
                aria-checked={isSelected}
                onKeyDown={e => {
                    e.keyCode === KEYS.enter ? props.onSelect(option.value) : ''
                }}
                onClick={() => props.onSelect(option.value)}
            >
                {option.label}
            </div>
        )
    }

    const labelText = `${props.label}${props.required ? '*' : ''}`;
    const groupClasses = props.hasError ? 'error' : '';

    return (
        <div className={ `input-toggle-button ${props.className}  ${props.disabled ? 'input-toggle-button--disabled' : ''}`}>
            <label className={props.hideLabel ? 'sr-only' : ''}>
                {labelText}
            </label>
            <div
                role="radiogroup"
                id={props.id}
                className={`input-toggle-button__radio-group ${groupClasses}`}
                aria-describedby={props.hasError && props.errorText ? `${props.id}-error` : undefined}
            >
                {props.options.map((opt) => {
                    return option(opt)
                })}
            </div>
            {props.hasError && props.errorText && (
                <div className="alert alert--danger alert--input mt-3" id={`${props.id}-error`}>
                    {props.errorText}
                </div>
            )}
        </div>
    )
}

export default InputToggleButton;
